import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { SubstanceThcClearanceItemModel } from '../types';

const substanceThcClearanceItemValidator: ValidateJSModel<SubstanceThcClearanceItemModel> = {
  Description: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  InvolvementDates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: {
      earliest: setToStartOfMonth(options?.applicantBirthdate),
      latest: DEFAULT_LATEST
    },
  }),
  // used in pvq and sf 
  EstimatedUse: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),
  Comments: {},
  HowManyTimes: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Reason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};

export default substanceThcClearanceItemValidator;
